/**
 * Shim for `react-native-config`.
 *
 * Maps the original RN env variable names to Vite `import.meta.env` values
 * (which must be prefixed with VITE_). Values are strings, matching the RN
 * library's behaviour (e.g. `Config.LOG_RESPONSES.toLowerCase()`).
 */
const env = import.meta.env;

const Config: Record<string, string> = {
  API_URL: env.VITE_API_URL ?? '',
  EMKIT_URL: env.VITE_EMKIT_URL ?? '',
  API_CLIENT_ID: env.VITE_API_CLIENT_ID ?? '',
  CLIENT_ID: env.VITE_CLIENT_ID ?? '',
  TENANT_ID: env.VITE_TENANT_ID ?? '',
  REDIRECT_URI: env.VITE_REDIRECT_URI ?? window.location.origin,
  // On the web MSAL redirects back to the SPA origin.
  IOS_REDIRECT_URI: env.VITE_REDIRECT_URI ?? window.location.origin,
  ANDROID_REDIRECT_URI: env.VITE_REDIRECT_URI ?? window.location.origin,
  ANDROID_DEBUG_REDIRECT_URI: env.VITE_REDIRECT_URI ?? window.location.origin,
  LOG_RESPONSES: env.VITE_LOG_RESPONSES ?? 'false',
  DD_RUM_APP_ID: env.VITE_DD_RUM_APP_ID ?? '',
  DD_RUM_CLIENT_TOKEN: env.VITE_DD_RUM_CLIENT_TOKEN ?? '',
  ENVIRONMENT_NAME:env.VITE_ENVIRONMENT_NAME ?? 'development',
};

export default Config;
